import { Base } from "ui/Scripts/source/framework/base";
import { ListItems } from "ui/Scripts/source/framework/listItems";
import { IRecordExpiredFamiliarizationListItem, RecordExpiredFamiliarizationListItem } from "./recordExpiredFamiliarizationListItem";

export interface IRecordExpiredFamiliarizationListItems extends ListItems<IRecordExpiredFamiliarizationListItem> { }

export class RecordExpiredFamiliarizationListItems extends ListItems<RecordExpiredFamiliarizationListItem> implements IRecordExpiredFamiliarizationListItems {
    constructor();
    constructor(obj: IRecordExpiredFamiliarizationListItems);
    constructor(obj?: any) {
        super(obj);
        this.items = Base.getTypedArray(obj ? obj.items : null, RecordExpiredFamiliarizationListItem);
    }
}